import { Pipe, PipeTransform } from '@angular/core';

import { LocaleService } from '../services/locale.service';
import { UnitSystem, UnitConversionValue, FsDistanceOptions } from '../types/unit-system';
import { UnitConverter } from '../utils/unit-conversion';
import { UnitConversionBasePipe } from './unit-conversion-base.pipe';

const DEFAULT_DISTANCE_OPTIONS: Required<FsDistanceOptions> = {
  precision: 1,
  includeUnit: true,
  sourceUnit: 'imperial',
};

@Pipe({
  name: 'fsDistance',
  pure: true,
})
export class FsDistancePipe extends UnitConversionBasePipe implements PipeTransform {
  constructor(_localeService: LocaleService) {
    super(_localeService);
  }

  transform(value: UnitConversionValue, options?: FsDistanceOptions | number): string {
    const opts = typeof options === 'number' 
      ? { ...DEFAULT_DISTANCE_OPTIONS, precision: options }
      : { ...DEFAULT_DISTANCE_OPTIONS, ...options };
    
    return this.convertAndFormat(
      value,
      opts.precision,
      opts.includeUnit,
      opts.sourceUnit,
      UnitConverter.convertMilesToKilometers,
      (system) => this._localeService.getUnitConfig().distance.symbol
    );
  }
}

